import { AxiosRequestConfig } from 'axios';
import queryString from 'query-string';

import Client from './client';
import { DynamicPageType } from './enums';
import { PageItem, Result } from './types';

type Response = {
  readonly result: Result;
  readonly status: number;
  readonly total: number;
  readonly dynamicPageId: string;
  readonly item: PageItem;
  readonly items: PageItem[];
};

export default (
  offset: number = 0,
  limit: number = 20,
  config?: AxiosRequestConfig
) => {
  return Client.get<Response>(
    `/slider/v1/dynamicPage/items/true?${queryString.stringify({
      offset,
      limit,
      pagesType: DynamicPageType.tourHome,
    })}`,
    config
  );
};
